import { __rest, __assign } from 'tslib';
import clsx from 'clsx';
import React from 'react';

var Label = function (_a) {
    var children = _a.children, className = _a.className, required = _a.required, htmlFor = _a.htmlFor, labelProps = __rest(_a, ["children", "className", "required", "htmlFor"]);
    var props = __assign({ className: clsx('c-input-label', className), required: required, htmlFor: htmlFor }, labelProps);
    return React.createElement("label", __assign({}, props), children);
};

export { Label };
//# sourceMappingURL=Label.js.map
